import { useEffect } from "react";
import { doc, onSnapshot, db, auth } from "../firebase";
import { USERS_COLLECTION } from "../constants/collections";
import { useAppDispatch } from "../redux/store";
import { setUser, FirestoreUser } from "../redux/slices/authSlice";

export default function useUserListener() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const userDocRef = doc(db, USERS_COLLECTION, auth.currentUser?.uid!);

    return onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const firestoreUser = docSnapshot.data() as FirestoreUser;
        const { createdAt, updatedAt, ...rest } = firestoreUser;

        dispatch(
          setUser({
            ...rest,
            uid: auth.currentUser?.uid!,
          }),
        );
      }
    });
  }, [dispatch]);
}
